import React, { useState } from "react";
import "./AddCourtPopup.css"; // reuse popup styles

export default function AddPartyPopup({ onAddParty }) {
  const [showPopup, setShowPopup] = useState(false);
  const [newParty, setNewParty] = useState({ 
    PartyName: "", 
    Father_Name: "",
    Mother_Name: "",
    Address: "",
    ContactNo: "",
    Email_Id: "",
    WhatsappNo: "",
    Party_Type: ""
});

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onAddParty(newParty); // call parent function
    setNewParty({ 
        PartyName: "", 
        Father_Name: "",
        Mother_Name: "",
        Address: "",
        ContactNo: "",
        Email_Id: "",
        WhatsappNo: "",
        Party_Type: ""
    });
    setShowPopup(false);
  };

  return (
    <div>
      {/* Button to open popup */}
      <button onClick={() => setShowPopup(true)}>Add Party</button>

      {/* Popup */}
      {showPopup && (
        <div className="popup-overlay">
            <div className="popup-container">
            <h2 className="popup-title">Add Party</h2>
            <form onSubmit={handleSubmit} className="popup-form">              
              <input
                type="text"
                placeholder="Party Name"
                value={newParty.PartyName}
                onChange={(e) =>
                  setNewParty({ ...newParty, PartyName: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Father Name"
                value={newParty.Father_Name}
                onChange={(e) =>
                  setNewParty({ ...newParty, Father_Name: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Mother Name"
                value={newParty.Mother_Name}
                onChange={(e) =>
                  setNewParty({ ...newParty, Mother_Name: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Address"
                value={newParty.Address}
                onChange={(e) =>
                  setNewParty({ ...newParty, Address: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Phon No"
                value={newParty.ContactNo}
                onChange={(e) =>
                  setNewParty({ ...newParty, ContactNo: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Email Id"
                value={newParty.Email_Id}
                onChange={(e) =>
                  setNewParty({ ...newParty, Email_Id: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Whats App No"
                value={newParty.WhatsappNo}
                onChange={(e) =>
                  setNewParty({ ...newParty, WhatsappNo: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Party Type"
                value={newParty.Party_Type}
                onChange={(e) =>
                  setNewParty({ ...newParty, Party_Type: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />

              <div className="popup-buttons">
                <button type="submit" className="btn-save">Save</button>
                <button type="button" className="btn-cancel" onClick={() => setShowPopup(false)} style={{ marginLeft: "10px" }}>Cancel</button>                
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
